<fs-badge [size]="size" [image]="image" [tooltip]="name" class="inline"></fs-badge>
<span class="name" *ngIf="shortName">{{firstName}} {{lastInitial}}.</span>
<span class="name" *ngIf="longName">{{name}}</span>
